import React, { useEffect, useState } from "react";
import { VariantServices } from "@/types/types.ts";
import { mappedServices } from "@/utils/services/serviceMapper.ts";
import { TransformedExtendedWarranty } from "@/types/serviceTypes.ts";
import { ArrowRightOutlined as ArrowRight } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { ListItem } from "@/components/__shared__/ListItem/ListItem";
import { ProtectPlusScheme } from "@/components/PostAddToBasketDrawer/scheme/schemeDecisioner.ts";
import { replaceVariables } from "@/components/PostAddToBasketDrawer/utils.ts";

export const OPEN_POST_ADD_TO_BASKET_DRAWER = "OPEN_POST_ADD_TO_BASKET_DRAWER";
export const PRE_ADD_TO_BASKET_DRAWER = "PRE_ADD_TO_BASKET_DRAWER_OPENED";

type Props = {
  variantServices: VariantServices;
  mode: BasketMode;
  protectPlusScheme: ProtectPlusScheme;
};

export enum BasketMode {
  Pre,
  Post,
}

function getPrice(warranty: TransformedExtendedWarranty): string {
  return warranty.display;
}

const AvailableServices = ({
  variantServices,
  mode,
  protectPlusScheme,
}: Props) => {
  const [services, updateServices] = useState<
    Array<TransformedExtendedWarranty>
  >([]);

  useEffect(() => {
    if (variantServices) {
      const warrantyServices = mappedServices(
        variantServices,
      ) as Array<TransformedExtendedWarranty>;

      updateServices(warrantyServices);
    }
  }, [variantServices]);

  if (!variantServices) return null;

  function handleClick(): void {
    window.dispatchEvent(
      new CustomEvent(
        mode === BasketMode.Pre
          ? PRE_ADD_TO_BASKET_DRAWER
          : OPEN_POST_ADD_TO_BASKET_DRAWER,
      ),
    );
  }

  return services.map((warranty, index) => {
    return (
      <ListItem
        key={index}
        data-testid={`extended-warranty-pa2b-header-${index + 1}`}
        label="Protect Plus"
        description={replaceVariables(protectPlusScheme.schemeHighlight || "", {
          VAR_YEARS: warranty.duration,
          VAR_PRICE: getPrice(warranty),
        })}
        trailingIcon={<ArrowRight size="medium" />}
        showBottomBorder={true}
        showTopBorder={true}
        onClick={handleClick}
      />
    );
  });
};

export default AvailableServices;
